import { sync, get } from 'vuex-pathify';

export default {
  computed: {
    tableSelectionType: sync('edit/tableSelectionType'),
    activeTool: get('tools/activeTool'),
  },
  methods: {
    toggleSelectionByType(type) {
      this.$root.$emit('moduleIdentification-action', { isActive: false, moduleRoute: '' });
      this.tableSelectionType = type;
      this.$root.$emit('selection-action', type);
      this.gridOptions.rowSelection = 'multiple';
      this.isSelectionActive = true;
    },
    toogleOffSelection(turnOnCustomLayerIdentification = true) {
      if (this.isCustomLayer && turnOnCustomLayerIdentification) {
        this.$root.$emit('moduleIdentification-action', {
          isActive: true,
          moduleRoute: this.customLayerData.routeName,
        });
      }
      this.tableSelectionType = undefined;
      if (this.activeTool !== 'identification') {
        this.$root.$emit('selection-action');
      }
      this.gridOptions.rowSelection = false;
      this.isSelectionActive = false;
      document.onkeydown = null;
      document.onkeyup = null;
    },
    highlightSelectedRows(selectedRows) {
      let toggleOffSelection = false;
      if (selectedRows && selectedRows.length > 0 && !this.isSelectionActive) {
        this.gridOptions.rowSelection = 'multiple';
        toggleOffSelection = true;
      }
      this.isSelectionEventDisabled = true;
      this.gridOptions.api.forEachNode(node => {
        if (!node || !node.data) {
          return;
        }
        node.setSelected((selectedRows || []).includes(node.id));
      });
      setTimeout(() => {
        this.isSelectionEventDisabled = false;
        if (toggleOffSelection) {
          this.gridOptions.rowSelection = false;
        }
      }, 0);
    },
    onSelectionChanged(e) {
      if (this.isSelectionEventDisabled) {
        return;
      }
      const selectedNodes = e ? e.api.getSelectedNodes() : this.gridOptions.api.getSelectedNodes();
      const selectedNodesIds = selectedNodes.map(node => node.id);
      this.clearSelection(selectedNodesIds?.length);
      this.$store.set('map/ADD_SELECTED_FEATURES!', {
        type: 'selectedFeatures',
        features: {
          [this.layerId]: selectedNodesIds,
        },
      });
    },
    async selectAllRows() {
      this.isAllRowsSelected = true;
      try {
        const r = await this.getLayerFeatures({
          layer_id: this.layerId,
          features_filter: this.handleGetFilter(),
          params: {
            ids_only: true,
            with_geometry: false,
          },
        });
        this.$store.set('map/ADD_SELECTED_FEATURES!', {
          type: 'selectedFeatures',
          features: {
            [this.layerId]: r.data.data.ids,
          },
        });
      } catch (e) {
        console.log(e);
      }
    },
    zoomToSelected() {
      this.$root.$emit('zoomToSelected');
    },
    clearSelection(selectedLength = this.currentLayerSelectedFeatures?.length) {
      this.isAllRowsSelected = false;
      if (this.isFilterSelectedActive && selectedLength === 0) {
        this.toggleFilterSelected();
      }
      if (this.isFilterSelectedActive) {
        this.handleFilter();
      }
      this.$store.set('map/DELETE_SELECTED_FEATURES!', {
        type: 'selectedFeatures',
        features: {
          [this.layerId]: [],
        },
      });
      this.gridOptions.api.deselectAll();
    },
  },
  watch: {
    activeTool(nV, oV) {
      if (nV !== oV && oV === 'selection') {
        this.tableSelectionType = undefined;
        this.gridOptions.rowSelection = false;
        document.onkeydown = null;
        document.onkeyup = null;
      }
    },
    computedIsDialogVisible() {
      this.currentNewRelationDataSourceDescAttributeVerboseName = 'ID';
    },
  },
  mounted() {
    this.$root.$on('toogleOffSelection', this.toogleOffSelection);
  },
};
